var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { InputGroupSimple as CoreInputGroupSimple } from '@gjensidige/core-forms';
import utils from '@gjensidige/core-utilities-css';
import classNames from 'classnames';
import { useController } from 'react-hook-form';
import sizing from '../../../utils/sizing.module.less';
export const InputGroupSimple = (_a) => {
    var _b, _c, _d;
    var { name, control } = _a, inputProps = __rest(_a, ["name", "control"]);
    const { field, fieldState } = useController({ control, name });
    const { ref } = field, renderProps = __rest(field, ["ref"]); // eslint-disable-line
    return (React.createElement(CoreInputGroupSimple, Object.assign({ topAlignInput: true }, inputProps, { legendClassName: classNames(utils['font-weight-medium'], [(_b = inputProps.legendClassName) !== null && _b !== void 0 ? _b : '']), className: classNames(sizing.mw500, [(_c = inputProps.className) !== null && _c !== void 0 ? _c : '']), errorText: (_d = fieldState.error) === null || _d === void 0 ? void 0 : _d.message, invalid: !!fieldState.error }, renderProps, { value: `${field.value}` })));
};
